
import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import AuthForm from './components/AuthForm';
import AuthSidePanel from './components/AuthSidePanel';

export default function AdminLogin() {
  const [activeTab, setActiveTab] = useState<'login' | 'signup'>('login');

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (session) {
          // Assuming a navigation helper is attached to the window object.
          // Guard against it not being defined.
          if (typeof window.REACT_APP_NAVIGATE === 'function') {
            window.REACT_APP_NAVIGATE('/admin');
          } else {
            console.warn('Navigation function not found on window');
          }
        }
      } catch (err) {
        console.error('Auth check failed:', err);
      }
    };
    checkAuth();
  }, []);

  const navigateHome = () => {
    if (typeof window.REACT_APP_NAVIGATE === 'function') {
      window.REACT_APP_NAVIGATE('/');
    } else {
      console.warn('Navigation function not found on window');
    }
  };

  return (
    <div className="min-h-screen bg-white flex">
      <AuthSidePanel activeTab={activeTab} />
      <div className="flex-1 flex items-center justify-center px-6 py-12 lg:px-16">
        <div className="w-full max-w-md">
          <div className="mb-10">
            <button
              onClick={navigateHome}
              className="flex items-center gap-2 text-sm text-slate-500 hover:text-emerald-600 transition-colors mb-8 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line"></i>
              Back to Home
            </button>
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 bg-emerald-500 rounded-full flex items-center justify-center">
                <i className="ri-leaf-line text-white text-lg"></i>
              </div>
              <span className="text-lg font-bold text-slate-900">GREENIFY</span>
            </div>
          </div>

          <div className="flex bg-slate-100 rounded-full p-1 mb-8">
            <button
              onClick={() => setActiveTab('login')}
              className={`flex-1 py-2.5 px-4 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeTab === 'login'
                  ? 'bg-white text-slate-900 shadow-sm'
                  : 'text-slate-500 hover:text-slate-700'
              }`}
            >
              Sign In
            </button>
            <button
              onClick={() => setActiveTab('signup')}
              className={`flex-1 py-2.5 px-4 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeTab === 'signup'
                  ? 'bg-white text-slate-900 shadow-sm'
                  : 'text-slate-500 hover:text-slate-700'
              }`}
            >
              Sign Up
            </button>
          </div>

          <AuthForm activeTab={activeTab} />
        </div>
      </div>
    </div>
  );
}
